namespace advisorop.components.common {

    export class SelectFilterSecurityCodeController {
        
        dg: DevExpress.ui.dxDataGridOptions;
        onIAmReady: any;
        selectedSymbol: domains.IBOSecurityDetail;
        selectedSymbolText: string;

        accountsPerSecId: Array<domains.IAccountBOAccountData> = [];
        accountsPerProduct: Array<domains.IAccountBOAccountData> = [];
        accounts: Array<domains.IAccountBOAccountData> = [];

        // search manager or product
        selectedSecurityProduct: domains.ISecurityProductDetail;
        selectedSecurityProductText: string;
        selectedProduct: any = {
            description: "not selected"
        };

        mainPanel: advisorop.components.widgets.AdvisoropPanelController;

        isAdvisor: boolean = false;
        tabName: string = "SECURITY";

        static $inject = ["generalService", "identityService", "accountApi", "advisorService", "$rootScope"];
        constructor(
            private generalService: services.GeneralService,
            private identityService: services.IdentityService,
            private accountApi: services.AccountApi,
            private advisorService: services.AdvisorService,
            private $rootScope: ng.IRootScopeService) {

            this.$rootScope.$on('adminModeChanged', (event: ng.IAngularEvent) => {
                if (this.selectedSecurityProduct && this.selectedSecurityProduct.uniqueSecId)
                    this.loadAccountsBySecId(this.selectedSecurityProduct.uniqueSecId);
            });
            
            this.dg = {
                export: {
                    enabled: false,
                    fileName: "Accounts"
                },
                bindingOptions: {
                    dataSource: "vm.accounts"
                },
                //height: 400,
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //paging: {
                //    //pageSize: 5,
                //    enabled: false
                //},
                rowAlternationEnabled: false,
                showBorders: true,
                showRowLines: true,
                showColumnLines: false,
                showColumnHeaders: true,
                columnAutoWidth: true,
                allowColumnReordering: true,
                allowColumnResizing: true,
                selection: {
                    mode: "single"
                },
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    width: 200,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                groupPanel: {
                    visible: false
                },
                grouping: {
                    autoExpandAll: true,
                    allowCollapsing: true,
                },
                columns: [
                    { dataField: "accountId", caption: "Account#", groupIndex: 0, autoExpandGroup: false, visible: true,
                        groupCellTemplate: (groupCell, info) => {
                            var item = this.extractData(info);
                            let labelText = "";
                            if (this.isAdvisor) {
                                labelText = `<a href="/advisor/accountsummary/${item.accountId}">${item.accountName} (${item.accountNumber})</a>
                                                <br/> Investors: `;
                                for (var i = 0; i < item.investors.length; i++) {
                                    //labelText += `<a href="/advisor/advisorinvestordashboard/${item.investors[i].id}">${item.investors[i].firstName} ${item.investors[i].lastName}</a>`;
                                    labelText += `<a href="/advisor/advisorinvestordashboard/${item.investors[i].id}">${item.investors[i].fullName}</a>`;
                                    if (i + 1 < item.investors.length)
                                        labelText += ", ";
                                }
                                if (this.tabName == "PRODUCT")
                                    labelText += `<br/> Product: ${item.productName}`;
                            } else {
                                labelText = `${item.accountName} (${item.accountNumber})
                                                <br/> Investors: `;
                                for (var i = 0; i < item.investors.length; i++) {
                                    //labelText += `${item.investors[i].firstName} ${item.investors[i].lastName}`;
                                    labelText += `${item.investors[i].fullName}`;
                                    if (i + 1 < item.investors.length)
                                        labelText += ", ";
                                }
                                if (this.tabName == "PRODUCT")
                                    labelText += `<br/> Product: ${item.productName}`;
                            }
                            $('<div>').html(labelText).appendTo(groupCell);
                        }
                    },
                    { dataField: "modelName", caption: "Account"},
                    { dataField: "usdMarketValue", caption: "Amount", format: "currency" }
                ],
                summary: {
                    groupItems: [{
                        column: "usdMarketValue", name: "sumAmount", summaryType: "sum",
                        alignByColumn: true, displayFormat: "{0}", valueFormat: "currency"
                    }]
                },
                sortByGroupSummaryInfo: [{sortOrder: "desc", summaryItem: "sumAmount"}]
            };
        }

        // for search product widget
        onProductSelected(boProduct: domains.ISecurityProductDetail): void {
            //console.log("Product has been selected: ", boProduct);
            this.selectedSecurityProduct = boProduct;
            this.loadAccountsByManagerProduct();
        }

        onBoSecuritySymbolSelected(boSecuritySymbol: domains.ISecurityProductDetail): void {
            //console.log("Product has been selected: ", boSecuritySymbol);
            this.selectedSecurityProduct = boSecuritySymbol;
            this.loadAccountsBySecId(this.selectedSecurityProduct.uniqueSecId);
        };

        extractData(e): any {
            var maxDepth = 5;
            var item = e;

            for (var d = 0; d < maxDepth; d++) {
                if (item.rowType === "group" && d == 0) {
                    item = item.data.items ? item.data.items[0] : item.data.collapsedItems[0];
                }
                else if ((item.items || item.collapsedItems) && d > 0) {
                    item = item.items ? item.items[0] : item.collapsedItems[0];
                }
                else if (!(item.items || item.collapsedItems) && d > 0) {
                    return item;
                }
                else if (item.rowType === "data") {
                    return item.data;
                }
            }
        }

        boSecuritySymbolSelected(boSecuritySymbol: domains.IBOSecurityDetail): void {
            this.selectedSymbol = boSecuritySymbol;
            this.loadAccountsBySecId(this.selectedSymbol.uniqueSecId);
            this.setSymbolText(this.selectedSymbol);
        };

        setSymbolText = (symbol: domains.IBOSecurityDetail) => {
            this.selectedSymbolText = `${symbol.name} (${symbol.uniqueSecId})`;
        }

        loadAccountsBySecId(uniqueSecId: string): void {
            const adminMode = this.advisorService.getAdminMode();
            const adminModeEnabled = adminMode && adminMode.enabled;

            this.mainPanel.showLoadingPanel();
            this.accountApi
                .getAccountsBySecurity(adminModeEnabled, uniqueSecId, adminModeEnabled ? adminMode.advisoryFirm.id : null)
                .then((response) => {
                    //console.log("Accounts per uniqueSecId loaded...");
                    this.accountsPerSecId = response.data;
                    this.accounts = this.accountsPerSecId;
                    this.mainPanel.hideLoadingPanel();
                }, error => {
                    this.mainPanel.hideLoadingPanel();
                    this.generalService.showError(error);
                });
        }

        loadAccountsByManagerProduct(): void {
            const adminMode = this.advisorService.getAdminMode();
            const adminModeEnabled = adminMode && adminMode.enabled;
            const advisoryFirmId = adminModeEnabled ? adminMode.advisoryFirm.id : null;

            this.mainPanel.showLoadingPanel();
            this.accountApi
                .getAccountsByManagerProduct(this.selectedSecurityProduct.managerId, this.selectedSecurityProduct.managerProductId, advisoryFirmId, adminModeEnabled)
                .then((response) => {
                    //console.log("Accounts per manager product loaded...");
                    this.accountsPerProduct = response.data;
                    this.accounts = this.accountsPerProduct;
                    this.mainPanel.hideLoadingPanel();
                }, error => {
                    this.mainPanel.hideLoadingPanel();
                    this.generalService.showError(error);
                });
        }

        onProductTabSelected() {
            this.accounts = this.accountsPerProduct;
            this.tabName = "PRODUCT";
            //console.log("onProductTabSelected");
        }

        onSecurityTabSelected() {
            this.accounts = this.accountsPerSecId;
            this.tabName = "SECURITY";
            //console.log("onSecurityTabSelected");
        }

        onMainPanelInit(ctrl) {
            this.mainPanel = ctrl;
        }

        $onInit(): void {
            this.identityService.getUserPromise().then(response => {
                var user = response;
                this.isAdvisor = (user.systemLoginType == domains.SystemLoginType.ADVISOR);
                this.onIAmReady({ ctrl: this });
            });
        }

        $onChanges(evt): void {
            //for (var key in evt) {
            //}
        }
    }


    class SelectFilterSecurityCode implements ng.IComponentOptions {
        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.controller = SelectFilterSecurityCodeController;
            this.controllerAs = "vm";
            this.bindings = {
                "onIAmReady": "&"
            };
            this.templateUrl = "spa/shared/common/select-filter-security-code.html";
        }
    }
    angular.module(Constants.APP).component("selectFilterSecurityCode", new SelectFilterSecurityCode());
}